import { render, staticRenderFns } from "./addSchool.vue?vue&type=template&id=377162ab&scoped=true&"
import script from "./addSchool.vue?vue&type=script&lang=js&"
export * from "./addSchool.vue?vue&type=script&lang=js&"
import style0 from "./addSchool.vue?vue&type=style&index=0&id=377162ab&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377162ab",
  null
  
)

export default component.exports